import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 7V4h16v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 20h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 4 8 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 15 5 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m20 15-5 5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RemoveFormatting";
const RemoveFormatting = memo(themed(Icon));
export {
  RemoveFormatting
};
//# sourceMappingURL=remove-formatting.js.map
